export const appVersion = 'rms-9154-remove-resolve-image-tag-from-build-files_5a5d87d';
